import axiosInstance from '../../../api/axiosConfig';

export const getGamStatus = async () => {
    const response = await axiosInstance.get('/publisher/gam/status');
    return response?.data;
};

export const connectGam = async () => {
    const response = await axiosInstance.get('/publisher/gam/connect');
    return response?.data;
};

export const disconnectGam = async () => {
    const response = await axiosInstance.delete('/publisher/gam/disconnect');
    return response?.data;
};
